import { useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert2";
import {
  Action,
  BatasBatasTanah,
  Deskripsi,
  SelectionField,
  ButtonGroup,
  InputField,
} from "./Inputs";
import Loading from "./Loading";
import { Add, Remove } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export default function FormCreate() {
  const types = ["tanah", "ruko", "rumah", "kantor"];
  const sertif = ["shm", "shgb", "shsrs", "hgu", "ajb", "girik", "shp"];

  const [tipe, setTipe] = useState(null);
  const [harga, setHarga] = useState(null);
  const [sertifikasi, setSertifikasi] = useState(null);
  const [luasTanah, setLuasTanah] = useState(null);
  const [luasBangun, setLuasBangun] = useState("-");
  const [bahan, setBahan] = useState("-");
  const [lantai, setLantai] = useState("-");
  const [dibangun, setDibangun] = useState("-");
  const [direnov, setDirenov] = useState("-");
  const [posisiBangunan, setPosisiBangunan] = useState("-");
  const [orientasi, setOrientasi] = useState("-");
  const [bentuk, setBentuk] = useState(null);
  const [elevasi, setElevasi] = useState(null);
  const [sumber, setSumber] = useState("-");
  const [noHPAdmin, setNoHPAdmin] = useState(null);
  const [noHPPemilik, setNoHPPemilik] = useState(null);
  const [alamat, setAlamat] = useState(null);
  const [wilayah, setWilayah] = useState(null);
  const [koordinat, setKoordinat] = useState(null);
  const [foto, setFoto] = useState([]);
  const [deskripsi, setDeskripsi] = useState([]);
  const [tanggalPenawaran, setTanggalPenawaran] = useState(null);

  const [depan, setDepan] = useState("");
  const [kiri, setKiri] = useState("");
  const [kanan, setKanan] = useState("");
  const [belakang, setBelakang] = useState("");
  const [loading, setLoading] = useState(false);

  const [countPhoto, setCountPhoto] = useState(1);

  const fields = [
    {
      label: "Harga (harga tertinggi)",
      type: "text",
      state: [harga, setHarga],
      required: true,
    },
    {
      label: "Luas Tanah (meter persegi)",
      type: "text",
      state: [luasTanah, setLuasTanah],
      required: true,
    },
    {
      label: "Bentuk Tanah",
      type: "text",
      state: [bentuk, setBentuk],
      required: true,
    },
    {
      label: "Elevasi",
      type: "text",
      state: [elevasi, setElevasi],
      required: true,
    },
    { label: "Sumber Informasi", type: "text", state: [sumber, setSumber] },
    {
      label: "No. Telp Admin (* 895-4398-dst)",
      type: "text",
      state: [noHPAdmin, setNoHPAdmin],
      required: true,
    },
    {
      label: "No. Telp Pemilik (* 895-4398-dst)",
      type: "text",
      state: [noHPPemilik, setNoHPPemilik],
      required: true,
    },
    {
      label: "Wilayah",
      type: "text",
      state: [wilayah, setWilayah],
      required: true,
    },
    {
      label: "Alamat",
      type: "text",
      state: [alamat, setAlamat],
      required: true,
    },
    {
      label: "Koordinat",
      type: "text",
      state: [koordinat, setKoordinat],
      required: true,
    },
    {
      label: "Tanggal Penawaran",
      type: "date",
      state: [tanggalPenawaran, setTanggalPenawaran],
      required: true,
    },
  ];

  const disabled = [
    {
      label: "Luas Bangunan (meter persegi)",
      type: "text",
      state: [luasBangun, setLuasBangun],
      disabled: tipe === "tanah",
      required: false,
    },
    {
      label: "Bahan Bangunan",
      type: "text",
      state: [bahan, setBahan],
      disabled: tipe === "tanah",
      required: false,
    },
    {
      label: "Jumlah Lantai",
      type: "text",
      state: [lantai, setLantai],
      disabled: tipe === "tanah",
      required: false,
    },
    {
      label: "Tahun Dibangun",
      type: "text",
      state: [dibangun, setDibangun],
      disabled: tipe === "tanah",
      required: false,
    },
    {
      label: "Tahun Direnovasi",
      type: "text",
      state: [direnov, setDirenov],
      disabled: tipe === "tanah",
      required: false,
    },
  ];

  const navigate = useNavigate();

  const handleTipe = (value) => {
    setTipe(value);
  };

  const handleSertifikasi = (value) => {
    setSertifikasi(value);
  };

  const validate = () => {
    if (
      !tipe ||
      !sertifikasi ||
      !luasTanah ||
      !harga ||
      !koordinat ||
      !alamat ||
      !bentuk ||
      !elevasi
    ) {
      return false;
    }
    return true;
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validate()) {
      swal
        .fire({
          title: "Tambah Data Gagal!",
          icon: "error",
          text: "Data yang diisi tidak lengkap!",
          confirmButtonText: "Close",
          timer: 1000,
        })
        .then(() => {
          setLoading(false);
        });
      return false;
    }

    const formData = new FormData();

    formData.append("tipe", tipe);
    formData.append("sertifikasi", sertifikasi);
    formData.append("harga", harga);
    formData.append("luasTanah", luasTanah);
    formData.append("luasBangun", luasBangun);
    formData.append("bahan", bahan);
    formData.append("alamat", alamat);
    formData.append("jumlahLantai", lantai);
    formData.append("direnov", direnov);
    formData.append("dibangun", dibangun);
    formData.append("posisiBangunan", posisiBangunan);
    formData.append("orientasi", orientasi);
    formData.append("batasTanah[]", depan);
    formData.append("batasTanah[]", kiri);
    formData.append("batasTanah[]", kanan);
    formData.append("batasTanah[]", belakang);
    formData.append("bentukTanah", bentuk);
    formData.append("elevasi", elevasi);
    formData.append("sumber", sumber);
    formData.append(
      "wilayah",
      wilayah.charAt(0).toUpperCase() + wilayah.slice(1)
    );
    formData.append("noHPAdmin", noHPAdmin);
    formData.append("noHPPemilik", noHPPemilik);
    formData.append("koordinat", koordinat);
    formData.append("deskripsi", deskripsi);
    formData.append("tanggalPenawaran", tanggalPenawaran);

    foto.forEach((file) => {
      formData.append("foto[]", file);
    });

    try {
      const response = await fetch(
        "https://kjpp-server.vercel.app/api/properties/create",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        swal
          .fire({
            title: "Tambah Data Success!",
            icon: "success",
            confirmButtonText: "Close",
            timer: 1000,
          })
          .then(() => {
            navigate("/");
          });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const convertBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleUpload = async (e, i) => {
    const photos = [...foto];
    const base64 = await convertBase64(e.target.files[0]);
    photos[i] = base64;

    setFoto(photos);
  };

  return (
    <form>
      {loading && (
        <div className="h-screen w-full flex justify-center items-center">
          <Loading />
        </div>
      )}
      {!loading && (
        <div className="flex flex-wrap justify-between gap-5">
          <div className="w-full mb-5 md:w-[48%]">
            <label
              htmlFor=""
              className="block mb-2 after:content-['*'] after:text-pink-500 after:ml-0.5"
            >
              Tipe
            </label>
            <ButtonGroup
              options={types}
              selectedOption={tipe}
              onChange={handleTipe}
            />
          </div>
          <div className="w-full mb-5 md:w-[48%]">
            <label
              htmlFor=""
              className="block mb-2 after:content-['*'] after:text-pink-500 after:ml-0.5"
            >
              Sertifikasi
            </label>
            <ButtonGroup
              options={sertif}
              selectedOption={sertifikasi}
              onChange={handleSertifikasi}
            />
          </div>
          {fields.map((field) => (
            <InputField
              label={field.label}
              type={field.type}
              value={field.state[0]}
              key={field.label}
              required={field.required}
              onChange={(e) => {
                field.state[1](e.target.value);
              }}
            />
          ))}
          {disabled.map((field) => (
            <InputField
              label={field.label}
              type={field.type}
              value={field.state[0]}
              key={field.label}
              onChange={(e) => {
                field.state[1](e.target.value);
              }}
              disabled={field.disabled}
            />
          ))}
          <BatasBatasTanah
            label={"Batas-batas Tanah"}
            depan={depan}
            kiri={kiri}
            kanan={kanan}
            belakang={belakang}
            setDepan={setDepan}
            setBelakang={setBelakang}
            setKanan={setKanan}
            setKiri={setKiri}
          />
          <div className="w-full mb-5 md:w-[48%]">
            <label htmlFor="" className="block mb-2">
              Foto
            </label>
            {Array.from({ length: countPhoto }).map((_, i) => (
              <input
                key={i}
                type="file"
                accept=".jpg, .png, .jpeg"
                className="border border-slate-400 rounded-md mb-2 px-4 py-[9px] w-full"
                onChange={(e) => {
                  handleUpload(e, i);
                }}
              />
            ))}

            <div className="flex">
              <IconButton
                onClick={() => {
                  setCountPhoto(countPhoto + 1);
                }}
              >
                <Add />
              </IconButton>

              <IconButton
                onClick={() => {
                  setFoto(foto.slice(0, countPhoto - 1));
                  setCountPhoto(countPhoto - 1);
                }}
                disabled={countPhoto < 2}
              >
                <Remove />
              </IconButton>
            </div>
          </div>
          <SelectionField
            label={"Posisi Bangunan / Tanah"}
            value={posisiBangunan}
            onChange={setPosisiBangunan}
            menus={["depan", "kanan", "tengah", "kiri", "belakang", "-"]}
          />
          <SelectionField
            label={"Orientasi Bangunan"}
            value={orientasi}
            onChange={setOrientasi}
            menus={[
              "utara",
              "barat",
              "timur",
              "selatan",
              "barat daya",
              "tenggara",
              "timur laut",
              "barat laut",
              "-",
            ]}
          />

          <Deskripsi
            label={"Deskripsi"}
            value={deskripsi}
            onChange={setDeskripsi}
          />

          <div className="w-full">
            <Action label={"Tambah data"} handleClick={handleCreate} />
          </div>
        </div>
      )}
    </form>
  );
}
